import React from "react";

import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { A5VALI } from "../../../Validation";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import HomeIcon from "@mui/icons-material/Home";
import moment from "moment/moment";
import ComponentLoader from "../../../../ComponentLoader";

function A5Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("");
  const [courseType, setCourseType] = useState("");
  const [Role, setRole] = useState("");
  const [thesistitle, setThesistitle] = useState("");
  const [fellowshipdetails, setFellowshipdetails] = useState("");
  const [thesissubmission, setThesissubmission] = useState("");
  const [date, setdate] = useState("");
  const [loader,setLoader] =useState(true);
  const [studentIdErr, setStudentIdErr] = useState(false);
  const [studentNameErr, setStudentNameErr] = useState(false);
  const [courseTypeErr, setCourseTypeErr] = useState(false);
  const [RoleErr, setRoleErr] = useState(false);
  const [thesistitleErr, setThesistitleErr] = useState(false);
  const [fellowshipdetailsErr, setFellowshipdetailsErr] = useState(false);
  const [thesissubmissionErr, setThesissubmissionErr] = useState(false);
  const [dateErr, setdateErr] = useState(false);

  const [dropcoursetype, setDropcoursetype] = useState([]);
  const [dropnatcoching, setDropnatcoching] = useState([]);
  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const [Lovrole, setLovrole] = useState([]);

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(A5VALI),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      handleLov(tok);
      handleCochingNaturetypes(tok);
      handleDirectorate(tok);
      handleCoursetypes(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head(" Student Guidance");
  }, []);
  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  const backs = () => {
    navigate("/A5");
  };
  const edit = (item) => {
    console.log(item);
    setStudentId(item.studentId);
    setStudentName( item.studentName);
    setCourseType(item.courseType);
    setRole(item.memberName);
    setThesistitle(item.thesistitle);
    setFellowshipdetails( item.fellowshipdetails);
    setdate(moment(item.thesissubmission).format("YYYY-MM-DD"));
    setId(item.id);
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  const handleCoursetypes = async (token) => {
    console.log(token);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.COURSEALL}`, {
        headers: h,
      });
      console.log(data);
      setDropcoursetype(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Lov
  const handleLov = async (token, MemberRole) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"MemberRole"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setLovrole(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Lov
  const handleCochingNaturetypes = async (token, CourseType) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"CourseType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setDropnatcoching(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);

    const d = {
      id,
      StudentId: studentId,
      StudentName: studentName,
      CourseType: courseType,
      MemberRole: Role,
      Thesistitle: thesistitle,
      Fellowshipdetails: fellowshipdetails,
      Thesissubmission: date,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.A5SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/A5");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }

        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.A5EDIT}`, d, {
          headers: h,
        });
        console.log(data);
        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/A5");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleDirectorate = async (token) => {
    console.log(token);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(`${window.BASE}${window.A5GETALL}`, {
        headers: h,
      });
      console.log(data); setLoader(false);
      // setStudentbtn(data);
    } catch (error) {
      console.log(error); setLoader(false);
    }
  };

  const formValidateFun = () => {
    if (!studentId) {
      setStudentIdErr(true);
      document.getElementById("studentId").focus();
    } else if (!studentName) {
      setStudentNameErr(true);
      document.getElementById("studentName").focus();
    } else if (!courseType) {
      setCourseTypeErr(true);
      document.getElementById("courseType").focus();
    } else if (!Role) {
      setRoleErr(true);
      document.getElementById("Role").focus();
    } else if (!thesistitle) {
      setThesistitleErr(true);
      document.getElementById("thesistitle").focus();
    } else if (!fellowshipdetails) {
      setFellowshipdetailsErr(true);
      document.getElementById("fellowshipdetails").focus();
    } else if (!date) {
      setdateErr(true);
      document.getElementById("date").focus();
    } else {
      handleLeavepage();
    }
  };

  return (
    <div className="main-container-margin">
      <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>Student Guidance (A5)</span>
        </div>
      </div>
      <form className="from-mains" onSubmit={handleSubmit(handleLeavepage)}>
        <div className="form-control">
          <h5 style={{ margin: 20 }}>A5. Student Guidance</h5>

          <TextField
            error={studentIdErr}
            id="studentId"
            label="Student Id"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={studentId}
            onChange={(e) => {
              setStudentId(e.target.value);
              setStudentIdErr(false);
            }}
          />

          <TextField
            error={studentNameErr}
            id="studentName"
            label="Student Name"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={studentName}
            onChange={(e) => {
              setStudentName(e.target.value);
              setStudentNameErr(false);
            }}
          />

          <FormControl
            style={{ width: "48%", margin: 12 }}
            error={courseTypeErr}
            id="courseType"
          >
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Degree
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Degree"
              size="small"
              sx={{ width: "100%" }}
              value={courseType}
              onChange={(e) => {
                setCourseType(e.target.value);
                setCourseTypeErr(false);
              }}
            >
              {dropnatcoching?.map((row) => {
                return (
                  <MenuItem key={row.lovName} value={row.lovName}>
                    {row.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          {/* <TextField
            error={memberNameErr}
            id="memberName"
            label="Member Name"
            variant="outlined"
            value={memberName}
            style={{ margin: "10px", width: "48%" }}
            onChange={(e) => {
              setMemberName(e.target.value);
              setMemberNameErr(false);
            }}
          /> */}
          <FormControl style={{ width: "48%", margin: 12 }} error={RoleErr} id="programtype">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Role
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="MeetingName"
              value={Role}
              label="Programme Type"
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setRole(e.target.value)
                setRoleErr(false)
              }}
            >
              {Lovrole?.map((row) => {
                return (
                  <MenuItem key={row.lovName} value={row.lovName}>
                    {row.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={thesistitleErr}
            id="thesistitle"
            label="Thesis Title (Max 500 Character)"
            variant="outlined"
            value={thesistitle}
            style={{ margin: "10px", width: "48%" }}
            onChange={(e) => {
              setThesistitle(e.target.value);
              setThesistitleErr(false);
            }}
          />

          <TextField
            error={fellowshipdetailsErr}
            id="fellowshipdetails"
            label="Fellowship Details (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={fellowshipdetails}
            onChange={(e) => {
              setFellowshipdetails(e.target.value);
              setFellowshipdetailsErr(false);
            }}
          />

          {/* <TextField
            error={thesissubmissionErr}
            id="thesissubmission"
            label="Thesis Submission"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={thesissubmission}
            onChange={(e) => {
              setThesissubmission(e.target.value);
              setThesissubmissionErr(false);
            }}
          /> */}

          <TextField
            error={dateErr}
            id="date"
            label="Date"
            type="date"
            variant="outlined"
            value={date}
            style={{ margin: "10px", width: "48%" }}
            onChange={(e)=>{
              setdate(e.target.value)
              setdateErr(false)
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              placeholder: "",
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA", height: "20px" }}
              onClick={backs}
            >
              Back
            </button>
            <button
              type="submit"
              className="sbmit-buttons"
              onClick={formValidateFun}
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default A5Inside;
